import Chart from "react-apexcharts";
import "flag-icons/css/flag-icons.min.css";

// Convert ISO code → country name
const COUNTRY_NAMES = new Intl.DisplayNames(["en"], { type: "region" });
const getCountryName = (code) => COUNTRY_NAMES.of(code) || code;

const MAX_SLOTS = 5;

const TopCountryVisitChart = ({ location = [], totalClicks }) => {
    // -----------------------------------
    // PAD DATA TO ALWAYS HAVE 5 SLOTS
    // -----------------------------------
    const paddedData = [...location];

    while (paddedData.length < MAX_SLOTS) {
        paddedData.push({
            code: "",
            clicks: 0
        });
    }

    // -----------------------------------
    // CHART VALUES
    // -----------------------------------
    const clicks = paddedData.map((c) => c.clicks || 0);
    const maxValue = Math.max(totalClicks) || Math.max(...clicks, 1);

    const series = [
        {
            name: "Clicks",
            data: clicks
        },
        {
            name: "Total Clicks",
            data: Array(MAX_SLOTS).fill(maxValue)
        }
    ];

    const options = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "40%",
                borderRadius: 8,
                borderRadiusApplication: "end"
            }
        },
        colors: ["#FA502E", "#FDE7E0"],
        dataLabels: { enabled: false },
        legend: { show: false },
        grid: { show: false },

        xaxis: {
            categories: Array(MAX_SLOTS).fill(""),
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: { show: false }
        },

        yaxis: {
            show: false,
            max: maxValue
        },

        tooltip: {
            enabled: true,
            y: {
                formatter: (val) => `${val.toLocaleString()} Clicks`
            }
        },

        fill: {
            opacity: [1, 0.3]
        }
    };

    return (
        <div className="w-full">
            {/* BAR CHART */}
            <Chart options={options} series={series} type="bar" height={280} />

            {/* COUNTRY LABELS */}
            <div className="grid grid-cols-5 gap-2 mt-[-20px]">
                {paddedData.map((item, index) => (
                    <div
                        key={index}
                        className="text-center text-theme_clr1 font-bold"
                    >
                        {item.code ? (
                            <>
                                {/* Flag */}
                                <span
                                    className={`fi fi-${item.code.toLowerCase()} rounded-full ring-4 ring-theme_clr2`}
                                />

                                <div className="text-sm mt-1">
                                    {getCountryName(item.code)}
                                </div>

                                <div className="text-xs text-theme_clr1/60">
                                    {item.clicks.toLocaleString()} clicks
                                </div>
                            </>
                        ) : (
                            // EMPTY SLOT (keeps layout stable)
                            <div className="opacity-0 select-none">
                                placeholder
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopCountryVisitChart;
